<template>
<div class="paper">
  <span>Let's Find a paper</span>
<img src="../assets/img/Trash-1.svg" alt="">
<div class="btn" @click="changePage">
  <span>+</span>
  <span>note</span>
</div>
</div>
</template>

<script>

export default {
  data() {
    return {
      mode: false
    }
  },
  methods: {
    changePage() {
      this.$router.push('/List')
    }
  }
}
</script>

<style lang="sass">

</style>